import { calculateDistance } from '@pflegia/util/common/distance';

const DISTANCE_FORMATTER = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

export const formatDistance = (km?: number | null): string | null => {
  if (km === null || km === undefined || !Number.isFinite(km) || km >= Number.MAX_SAFE_INTEGER) return null;
  return `${DISTANCE_FORMATTER.format(km)} km`;
};

export const getDistanceInKm = (candidateCoordinates?: number[] | null, jobCoordinates?: number[] | null): number | null => {
  if (!candidateCoordinates || !jobCoordinates) return null;

  const distance = calculateDistance(candidateCoordinates[1], candidateCoordinates[0], jobCoordinates[1], jobCoordinates[0]);
  return distance >= Number.MAX_SAFE_INTEGER ? null : distance;
};

export const hasValidCoordinates = (coordinates?: number[] | null): boolean =>
  Array.isArray(coordinates) &&
  coordinates.length === 2 &&
  coordinates.every(coordinate => typeof coordinate === 'number' && Number.isFinite(coordinate));
